import buildFormData, { FormParams } from "@utils/buildFormData";
import { PostRequest } from "./http/BaseRequest";
import { RcFile } from "antd/es/upload";
import { BaseResponse } from "./http/responses/BaseResponse";

export interface UploadPhotoResponse extends BaseResponse {
  readonly Link: string;
}

export class UploadMinerPhotos extends PostRequest {
  constructor(params: { minerid: string; photo: string | RcFile | Blob }) {
    super("/admin/miner/photo/add", buildFormData(params));
  }
}

export class DeleteMinerPhotos extends PostRequest {
  constructor(params: { minerid: string; photo: string }) {
    super("/admin/miner/photo/delete", params);
  }
}
